import React from 'react'
import QuestionInfo from '../../components/Questions/QuestionInfo'

const QuestionInfoPage = () => {
  return (
    <QuestionInfo />
  )
}

export default QuestionInfoPage